function venue_grid_init() {

    if( ! document.querySelectorAll('.venue-search-page').length )
        return;

    // console.log(venue_wp_data['ctcrm-lympstone']);

    let venue_card_cls = '.venue-row';

    // move h1
    let header_element = document.createElement('div'),
        h1 = document.querySelector('h1'),
        search = document.querySelector('.venue-search-form'),
        venue_list_element = document.querySelector('.venue-search-page');
    header_element.append(h1, search);
    header_element.classList.add('header');
    venue_list_element.prepend(header_element);

    document.querySelectorAll(venue_card_cls).forEach(element => {
        // console.log(element);

        let wp_data = venue_wp_data[venue_get_id(element)];
        // console.log(wp_data);

        // remove on_click
        element.removeAttribute('onClick');

        // convert element to anchor, ignoring container from here out
        element = element.querySelector('a');

        if( wp_data ) {
            // tags
            if( wp_data.tags )
                venue_card_add_tags(element, wp_data.tags);

            // flash
            if( wp_data.flash )
                venue_card_add_element('flash', element, wp_data.flash);
            
            // flash
            if( wp_data.flash_2 )
                venue_card_add_element('flash_secondary', element, wp_data.flash_2);

            // image
            if( wp_data.img_cover )
                venue_card_add_img(element, wp_data.img_cover);

            // name
            if( wp_data.name ) {
                var existing = element.querySelector('.venue-name').textContent;
                var has_distance = existing.includes('Distance');

                if( has_distance )
                    wp_data.name += ' <span>' + existing.substring( existing.indexOf('('), existing.lastIndexOf(')') + 1 ) + '</span>';

                element.querySelector('.venue-name').innerHTML = wp_data.name;
            }
                

            // city
            if( wp_data.city )
                element.querySelector('.venue-town').innerHTML = wp_data.city;
        }

        // venue name string trim
        // let venue_name_element = element.querySelector('.venue-name'),
        //     venue_name_element__content = venue_name_element.textContent,
        //     trim_qty = 3;
        // venue_name_element.innerHTML = venue_name_element__content.substring(0, venue_name_element__content.length - trim_qty);
    });
    
}

function venue_get_id(element) {
    if( element.getAttribute('onClick') !== null ) {
        let url_components = element.getAttribute('onClick').split('/');
        slug = url_components[url_components.length - 1].slice(0, -1);
    } else {
        let url_components = element.querySelector('a').getAttribute('href').split('/');
        slug = url_components[url_components.length - 1];
    }
    
    return slug;
}

function venue_card_add_img(element, data) {
    let figure = document.createElement('figure'),
        img = document.createElement('img');
    img.setAttribute('src', data);
    figure.append(img);
    element.append(figure);
}

function venue_card_add_element(label, element, data) {
    let this_element = document.createElement('div');
    this_element.classList.add(label);
    this_element.append(data);
    element.append(this_element);
}

function venue_card_add_tags(element, tags) {
    let tags_element = document.createElement('div');

    tags_element.classList.add('tags');
    
    tags.forEach(tag => {
        let this_tag = document.createElement('div');

        this_tag.setAttribute('data-type', tag.type);
        this_tag.append(tag.label);

        if( tag.type == 'facility' ) {
            this_tag.classList.add(tag.label.toLowerCase().replace(/ /g, '_'));
        }

        tags_element.append(this_tag);
    });

    element.append(tags_element);
}

jQuery(document).ready(function() {
    venue_grid_init();
});